import { DatePicker, Form, Radio } from "antd";
import { Select } from "antd";
import { Input } from "antd";
import { Col, Row } from "antd";
import React, { FC } from "react";
import { IFetchAllDetails } from "../../../../../interfaces/IPatient";

type TreatmentProps = {
  formattedConsultationType: Array<{ label: string; value: string }>;
  govtHospitalList: any;
  diagnosisList: any;
  patientStore: IFetchAllDetails | null;
  form: any;
  portalData: any;
  isApproved: boolean;
};

const Treatment: FC<TreatmentProps> = (props) => {
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  const primaryDiagnosis = Form.useWatch("primaryDiagnosis", props?.form);

  return (
    <>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "18px",
          marginBottom: "6px",
          fontWeight: "bold",
        }}
      >
        Treatment Details
      </div>
      <Form
        form={props?.form}
        //   onFinish={handleSubmit}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%",padding:"8px" }}
      >
        <Row gutter={[16, 16]}>
          {props?.patientStore?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "CGHS" ? (
            (props?.patientStore?.referralInfoResponse?.cghsReferralResponse
              ?.id &&
              props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
                "EMERGENCY") ||
            ((props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
              "IP" ||
              props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
                "OP") &&
              props?.patientStore?.patientResponse?.age < 70) ||
            (props?.patientStore?.referralInfoResponse?.cghsReferralResponse
              ?.id &&
              props?.patientStore?.patientResponse?.age > 70) ||
            props?.patientStore?.referralInfoResponse?.cghsReferralResponse
              ?.id ? (
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={6} lg={6} xl={6}>
                  <Form.Item
                    label="IS REFERRAL TYPE?"
                    name="referralType"
                    style={{ color: "black" }}
                    rules={[
                      {
                        required: true,
                        message: "Please select referral type",
                      },
                    ]}
                  >
                    <Radio.Group
                      options={[
                        { label: "MANUAL", value: "manual" },
                        { label: "E-REFERRAL", value: "e-referral" },
                      ]}
                      disabled={props?.portalData?.casePreAuthCghs?.claimId}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                  <Form.Item
                    label="REFERRAL NO"
                    name="referralNumber"
                    style={{ color: "#575757" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input Referral No",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Please input Referral No"
                      style={{ color: "black" }}
                      disabled={props?.portalData?.casePreAuthCghs?.claimId}
                      autoComplete="off"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                  <Form.Item
                    label="REFERRAL TYPE"
                    name="consultationType"
                    style={{ color: "#575757" }}
                    rules={[
                      {
                        required: true,
                        message: "Please select REFERRAL TYPE",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      disabled={props?.portalData?.casePreAuthCghs?.claimId}
                      placeholder="Select a REFERRAL TYPE"
                      options={props?.formattedConsultationType?.map(
                        (option) => ({
                          value: option?.value + "~" + option?.label,
                          label: option?.label,
                        })
                      )}
                      allowClear
                      style={{ color: "black" }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                  <Form.Item
                    label="REFERRAL DATE"
                    name="referralDate"
                    style={{ color: "black" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input REFERRAL DATE",
                      },
                    ]}
                  >
                    <DatePicker
                      style={{ width: "100%" }}
                      format={dateFormat}
                      disabled={props?.portalData?.casePreAuthCghs?.claimId}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                  <Form.Item
                    label="REFERRAL BY"
                    name="referralBy"
                    style={{ color: "#575757" }}
                    rules={[
                      {
                        required: true,
                        message: "Please input Referral By",
                      },
                      {
                        pattern: /^[a-zA-Z\s]*$/,
                        message: "Only alphabets and spaces are allowed",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Please input Referral By"
                      style={{ color: "black" }}
                      disabled={props?.portalData?.casePreAuthCghs?.claimId}
                      autoComplete="off"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={7} lg={7} xl={7}>
                  <Form.Item
                    label="WELLNESS CENTER NAME/GOVERNMENT HOSPITAL"
                    name="govtHospital"
                    style={{ color: "#575757" }}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message:
                    //       "Please select WELLNESS CENTER NAME/GOVERNMENT HOSPITAL",
                    //   },
                    // ]}
                  >
                    <Select
                      showSearch
                      disabled={props?.portalData?.casePreAuthCghs?.claimId}
                      placeholder="Select a WELLNESS CENTER NAME/GOVERNMENT HOSPITAL"
                      options={props?.govtHospitalList?.map((option: any) => ({
                        value:
                          option?.govtHospitalCode +
                          "~" +
                          option?.govtHospitalName,
                        label: option?.govtHospitalName,
                      }))}
                      allowClear
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={4} lg={4} xl={4}>
                  <Form.Item
                    label="REMARKS"
                    name="remarks"
                    style={{ color: "#575757" }}
                    //   rules={[
                    //     {
                    //       required: true,
                    //       message: "Please input Remarks",
                    //     },
                    //   ]}
                  >
                    <Input
                      placeholder="Please input Remarks"
                      style={{ color: "black" }}
                      disabled={props?.portalData?.casePreAuthCghs?.claimId}
                      autoComplete="off"
                    />
                  </Form.Item>
                </Col>
              </Row>
            ) : (
              <></>
            )
          ) : (
            <></>
          )}

          <Col xs={24} sm={12} md={4} lg={4} xl={4} style={{ paddingLeft: 0 }}>
            <Form.Item
              label="PRIMARY DIAGNOSIS"
              name="primaryDiagnosis"
              style={{ color: "#575757" }}
              rules={[
                {
                  required: true,
                  message: "Please select Primary Diagnosis",
                },
              ]}
            >
              <Select
                showSearch
                disabled={props?.portalData?.casePreAuthCghs?.claimId}
                placeholder="Select a Primary Diagnosis"
                options={props?.diagnosisList?.map((option: any) => ({
                  value:
                    option?.primaryDiagnosisCode +
                    "~" +
                    option?.primaryDiagnosisName,
                  label: option?.primaryDiagnosisName,
                }))}
                allowClear
              />
            </Form.Item>
          </Col>

          {primaryDiagnosis?.split("~")?.[1]?.toUpperCase() === "OTHER" ? (
            <Col xs={24} sm={12} md={4} lg={4} xl={4}>
              <Form.Item
                label="DIAGNOSIS DESCRIPTION"
                name="diagnosisDescription"
                style={{ color: "#575757" }}
                rules={[
                  {
                    required: true,
                    message: "Please input Diagnosis Description",
                  },
                ]}
              >
                <Input
                  placeholder="Please input Diagnosis Description"
                  style={{ color: "black" }}
                  disabled={props?.portalData?.casePreAuthCghs?.claimId}
                />
              </Form.Item>
            </Col>
          ) : (
            <></>
          )}
        </Row>
      </Form>
    </>
  );
};

export default Treatment;
